/**
 * @param {string} base64
 * @param {string} contentType
 * @return {Blob}
 */
export const blobFromBase64 = (base64, contentType) => {
  let type = contentType;
  let decodedData = window.atob(base64);

  if (base64.startsWith('data:')) {
    [type, decodedData] = base64.split(';base64,');

    [, type] = type.split(':');
    decodedData = window.atob(decodedData);
  }

  const uInt8Array = new Uint8Array(decodedData.length);
  for (let i = 0; i < decodedData.length; i++) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type });
};

/**
 * @param {Blob} blob
 * @param {string} fileName
 */
const downloadFromBlob = (blob, fileName) => {
  if (navigator.msSaveBlob) {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;

    tempLink.setAttribute('download', fileName);

    document.body.appendChild(tempLink);
    tempLink.click();

    // Fixes "webkit blob resource error 1"
    setTimeout(() => {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 0);
  }
};

/**
 *
 * @param {string} file
 * @param {string} type
 * @param {string} fileName
 */
export const downloadBase64 = (file, type, fileName) => {
  const blob = blobFromBase64(file, type);
  downloadFromBlob(blob, fileName);
};

/**
 * Download a file from an external url and rename it
 * @param {string} file
 * @param {string} givenFileName
 */
export const downloadFile = async (file, givenFileName) => {
  const downloadLink = document.createElement('a');

  downloadLink.style.display = 'none';
  downloadLink.setAttribute('href', file);
  downloadLink.setAttribute('download', givenFileName);

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
